import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ListSelectComponent, MbsPopupType, TableCellDirective } from 'mbs-ui-kit';
import { StorageConnection } from 'mbs-ui-shared@models/storge-connections';
import { StorageTypeIconPipe } from 'mbs-ui-shared@utils/pipes/storage-type-icon.pipe';
import { WhereBackupStepLogic } from '../where-backup-step.logic';

@UntilDestroy()
@Component({
  selector: 'mbs-where-backup-step-storage-list',
  templateUrl: './where-backup-step-storage-list.component.html',
  imports: [CommonModule, AlertComponent, ListSelectComponent, TableCellDirective, StorageTypeIconPipe, I18NextPipe]
})
export class WhereBackupStepStorageListComponent {
  @Input() id: string;
  @Input() storages: StorageConnection[] = [];
  @Input() selectedStorages: string[] = [];
  @Input() disableRowTooltip: string;
  @Input() maxHeight: string;
  @Input() invalid: boolean;

  @Output() rowClick: EventEmitter<void> = new EventEmitter();
  @Output() changeSelected: EventEmitter<string[]> = new EventEmitter<string[]>();

  public readonly mbsPopupType = MbsPopupType;
  public readonly elementsSelector = {
    id: {
      listLocalStorages: 'list-local-storages',
      listLocalOrCloudStorages: 'list-local-or-cloud-storages'
    },
    name: {
      configNotSupportedAlert: 'configNotSupportedAlert',
      noStoragesAlert: 'noStoragesAlert',
      needNewStorageAlert: 'needNewStorageAlert',
      notLocalStorageAlert: 'notLocalStorageAlert',
      radioButtonsBox: 'radioButtonsBox',
      loaderItem: 'loaderItem',
      listSelectLocalOrCloud: 'listSelectLocalOrCloud',
      listSelectLocal: 'listSelectLocal'
    }
  };

  public headers = WhereBackupStepLogic.headers;

  public get noData(): boolean {
    return !this.storages.length;
  }
}
